import Vue from 'vue';
import { defineAsyncComponent } from 'vue';

const NavigationTree = defineAsyncComponent(() => import('@/project/search/navigation/NavigationTree.vue'));

Vue.component('NavigationTree', NavigationTree);
